export default __webpack_public_path__ + "static/media/icon_users.fc71ee56.svg";